// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal[data-v-749be169] .v--modal-box.v--modal {
  overflow: visible;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .header {
  padding: 15px 20px 0px 15px;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body {
  padding-top: 1em;
  height: 100%;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-image,
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-name {
  display: flex;
  justify-content: center;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-image {
  display: flex;
  justify-content: center;
  padding-bottom: 0.7em;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-image .icon-block {
  width: 3em;
  height: 3em;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-name {
  font-size: 1.3em;
}
.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-members {
  display: flex;
  justify-content: center;
}
.custom-modal[data-v-749be169] .custom-input-text-placeholder.up {
  font-size: 0.8em;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatGroupJoinGroup.vue"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".custom-modal[data-v-749be169] .v--modal-box.v--modal {\n  overflow: visible;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .header {\n  padding: 15px 20px 0px 15px;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body {\n  padding-top: 1em;\n  height: 100%;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-image,\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-name {\n  display: flex;\n  justify-content: center;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-image {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 0.7em;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-image .icon-block {\n  width: 3em;\n  height: 3em;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-name {\n  font-size: 1.3em;\n}\n.custom-modal[data-v-749be169] .v--modal-box.v--modal .body .content-body .group-members {\n  display: flex;\n  justify-content: center;\n}\n.custom-modal[data-v-749be169] .custom-input-text-placeholder.up {\n  font-size: 0.8em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
